import {
  makeStyles,
  Box,
  FormControl,
  Select,
  useTheme,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Report } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { MdFilterList } from "react-icons/md";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { backend } from "../../../api";
import { toast } from "react-toastify";
import { useParams } from "react-router";

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.secondary.dark}`,
    margin: "20px 0",
  },
  sectionHeading: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  cmntsBox: {
    border: `1px solid ${theme.palette.primary.main}`,
    margin: "10px 5px",
    padding: 5,
    borderRadius: "10px",
    // backgroundColor: theme.palette.secondary.dark,
    "&:hover": {
      "& $btnsBox": {
        visibility: "visible",
      },
    },
  },
  btnsBox: {
    textAlign: "right",
    marginTop: "-15px",
    visibility: "hidden",
    marginRight: "10px",
    marginBottom: 0,
  },
  cmntMsg: {
    margin: 0,
    marginTop: "-10px",
  },
  acceptBtn: {
    margin: 0,
    padding: 3,
    fontSize: 20,
    backgroundColor: "white",
    color: theme.palette.success.main,
  },
  rejectBtn: {
    margin: 0,
    padding: 3,
    fontSize: 20,
    backgroundColor: "white",
    color: theme.palette.error.main,
  },
  cmntsItem: {
    color: theme.palette.secondary.light,
    fontSize: "12px",

    // backgroundColor: theme.palette.secondary.dark,
    borderRadius: "10px",
    padding: "10px",
    margin: "2px 0",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
    // borderTop: `1px solid ${theme.palette.primary.main}`,
    "&:hover": {
      "& $reportBtn": {
        visibility: "visible",
      },
    },
  },
  userName: {
    color: theme.palette.secondary.dark,
    margin: 0,
  },
  reportBtn: {
    margin: 0,
    padding: 2,
    fontSize: 10,
    visibility: "hidden",
  },
}));

function Reviews(props) {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { reviews, currentBook } = props;
  const [reviewsList, setReviewsList] = useState();
  const handleFilterReviews = (e) => {
    if (e.target.value === "active") {
      setReviewsList(
        currentBook.reviews.filter(
          (comment) => !comment.reported && comment.approved
        )
      );
    } else if (e.target.value === "blocked") {
      setReviewsList(
        currentBook.reviews.filter((comment) => !comment.approved)
      );
    } else if (e.target.value === "reported") {
      setReviewsList(
        currentBook.reviews.filter(
          (comment) => comment.reported && comment.approved
        )
      );
    } else {
      setReviewsList(currentBook.reviews);
    }
  };
  useEffect(() => {
    fetchCurrentBook();
  }, []);
  const fetchCurrentBook = () => {
    setReviewsList(
      currentBook.reviews.filter(
        (comment) => !comment.reported && comment.approved
      )
    );
  };
  const handleReportReview = (id) => {
    backend
      .post("/review/request/report", { review: id })
      .then((res) => {
        Swal.fire({
          title: "Congratulations",
          icon: "success",
          confirmButtonText: "OK",
          text: res.data.message,
        }).then((result) => {
          window.location.reload();
        });
      })
      .catch((err) => {
        if (err.response) {
          toast.error(err.response.data.message);
        } else {
          toast.error(err.message);
        }
      });
  };
  return (
    <div className={classes.root}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={4}
      >
        <h2 className={classes.sectionHeading}>Reviews</h2>
        <Box display="flex" alignItems="center">
          <MdFilterList style={{ margin: "0 5px", fontSize: 20 }} />
          <FormControl
            variant="outlined"
            className={classes.filterSelect}
            startIcon={<MdFilterList />}
          >
            <Select native onChange={handleFilterReviews}>
              <option value="active">Active</option>
              <option value="blocked">Blocked</option>
              <option value="reported">Reported</option>
            </Select>
          </FormControl>
        </Box>
      </Box>
      {reviewsList && (
        <Box>
          {reviewsList.length === 0 ? (
            <Box>
              <Typography variant="h6" color="error">
                No reviews Till yet
              </Typography>
            </Box>
          ) : (
            <Box>
              {reviewsList.map((comment) => (
                <Box className={classes.cmntsItem}>
                  <p style={{ margin: 0 }}>{comment.comment}</p>
                  <Box
                    m={0}
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    {!comment.reported && (
                      <IconButton
                        className={classes.reportBtn}
                        onClick={() => handleReportReview(comment._id)}
                      >
                        <Report />
                      </IconButton>
                    )}
                    <p className={classes.userName}>
                      - {comment.customer.name}
                    </p>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </Box>
      )}
    </div>
  );
}

export default Reviews;
